/**
 * customersのreportのevaluationを動的に扱うformです
 */
import $ from 'jquery';

(() => {
  document.addEventListener('turbolinks:load', () => {
    // 送信と送信先の切り替えはモーダルのボタン（formaction）に任せ、ここでは二重送信だけ防ぐ
    $('#evaluation_form').on('submit', () => {
      $('#approveModalSubmit, #rejectModalSubmit').prop('disabled', true);
    });
  });
})();
